module.exports = __webpack_public_path__ + "img/goodrx.54060b0.jpg";